<template>
  <div class="similarity-news-item-container">
    <div class="left">
      <div class="title-container">
        <a class="news-title" :href="data.url" target="_blank">{{data.title}}</a>
      </div>
      <div> 
        <span class="date">{{data.date}}</span>
        <span class="source">{{data.source}}</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'similarity-news-list-item',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.similarity-news-item-container {
  margin: 0 24px;
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow:0px -1px 0px 0px rgba(247,247,250,1);

  .left {
    .title-container {
      display: flex;
      align-items: center;
    }
    .date {
      font-family: DIN-Regular;
      font-size: 12px;
      color: #747990;
      margin-right: 16px;
    }

    .source {
      margin-right: 16px;
      font-size: 12px;
      color: #747990;
      
    }
    .news-title {
      margin-bottom: 8px;
      font-size: 14px;
      font-weight:500;
      color:rgba(23,31,70,1);
      text-decoration: none;
      &:hover{
        text-decoration: underline;
      }
    }    
  }
}
</style>
